<template>
    <v-row justify="center" align="center" no-gutters>
        <v-col cols="12" xl="8" lg="8" md="10" sm="10">

            <v-row justify="center" no-gutters>
                <span class="text-h6 text-sm-h5 text-center">Record Your Voice</span>
            </v-row>

            <v-row justify="center" no-gutters class="mt-4">
                <v-col cols="12" xl="9" lg="10" md="12" sm="12" xs="12" class="px-xl-15 px-lg-10 px-md-5">
                    <TextCreationIndexCardContainer
                        :textPost="textPost"
                        :textCardIndexAssociationValue="textCardIndexAssociationValue"
                        :triggerAnimationAfterRecord="triggerAnimationAfterRecord"
                        @textIndexChevronPressed="changeTextCardIndexAssociationValue"
                    />
                </v-col>

                <v-row justify="center" class="ma-0 pa-0">
                    <v-col cols="12" xl="10" lg="10" md="12" sm="12">
                        <v-row v-if="isMobile" justify="end" align="center" class="full-width mx-0">
                            <TextRecordProgressBar :emitTime="emitTime" :timePlaying="timePlaying" :showProgressBar="showProgressBar" class="mt-0 mb-2"/>
                            <Push :isDraftPost="isDraftPost" :tawqin="tawqin" :showProgressBar="showProgressBar" :editState="editState" :isTextPostCreation="true" @controlRecordState="controlRecordState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/>
                            <!-- <Pickup v-if="!userData.pushToTawq" :isDraftPost="isDraftPost" :tawqin="tawqin" @controlVideoState="controlVideoState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/> -->
                        </v-row>

                        <v-row v-else justify="space-between" align="center">
                            <TextRecordProgressBar :emitTime="emitTime" :timePlaying="timePlaying" :showProgressBar="showProgressBar"/>
                            <Push :isDraftPost="isDraftPost" :tawqin="tawqin" :showProgressBar="showProgressBar" :editState="editState" :isTextPostCreation="true" @controlRecordState="controlRecordState" @emitAudioSeg="updateTawqDataAfterUploadAudioRec"/>
                        </v-row>
                    </v-col>

                    <v-col cols="12" xl="10" lg="10" md="12" sm="12" class="caption-card-container d-flex flex-column-reverse inverseGrey py-6">
                        <TextCaptionCard
                            v-for="(data, key) in tawqData"
                            :key="parseInt(key)"
                            :index="parseInt(key)"
                            :showCaptions="(textPost.languageSelected.text === 'None (Disable Auto Captions)' ? false : true)"
                            :loading="data.caption === null || data.audio.audioURL === null"
                            :videoDuration="0"
                            @deleteAudioSegment="deleteAudioSegment"
                            @audioPlay="playAudioSegment"
                            @updateScroll="updateScroll"
                            @editState="sendEditStateToPush"
                        />
                        <v-divider v-if="hasAudio"/>
                        <div :class="(textPost.languageSelected.text === 'None (Disable Auto Captions)' ? 'mb-2' : '')" class="text-lg-subtitle-2 text-caption text-center">{{((textPost.languageSelected.text === 'None (Disable Auto Captions)' && !showCaptions) ? 'Automatic captioning has been disabled. To enable, go to back to step 1 and select the language you will be speaking. You must record at least once to move to the review process.' : (textPost.languageSelected.text === 'None (Disable Auto Captions)' && showCaptions) ? 'Automatic captioning has been disabled. To enable, delete your current segments and go to back to step 1 and select the language you will be speaking.' : (!showCaptions ? 'You must record at least once to move to the review process.' : ''))}}</div>
                    </v-col>
                </v-row>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import firebase from "../../../firebaseConfig";
import TextCreationIndexCardContainer from "./TextCreationIndexCardContainer.vue";
import TextCaptionCard from "./TextCaptionCard";
import Push from "../Mobile/Push";
// import Pickup from "../Mobile/Pickup";
import TextRecordProgressBar from "./TextRecordProgressBar.vue";

export default {
    props: ["previewVideo", "propPostData", "propAudioData", "matchAudioStartTimesWithSelectedContribution"],
    components: {
        TextCreationIndexCardContainer,
        TextCaptionCard,
        Push,
        // Pickup,
        TextRecordProgressBar,
    },
    data: function () {
        return {
            isDraftPost: false, // in contribution this will always be false. We send value to push/pickup, so we need to set it to false here.
            currentMobile: {
                state: "@pause",
                prevState: "@play",
            },
            segStart: "",
            textSeg: {
                segment: 0,
                vStart: null,
            },
            vIgnore: 0.5,
            tawqin: {},
            dbRefs: {
                subtitleRef: null,
                conversionRef: null,
            },

            textCardIndexAssociationValue: 0,

            emitTime: 0,
            timePlaying: 60000,
            INTERVAL: 1000,
            captionTimer: null,
            showProgressBar: false, // not really necessary right here but is in legacy code
            editState: false,
            showCaptions: false,
            showContributions: false,
            showContributionDialogForMobile: false, // this is for mobile screens, and will show the dialog so that the user can select contributions
            showSelectedContributionTimeout: null,
            mobileAudioElementSelected: null, // true if play button on audioElement selected, false if play button on audioSegment selected.
            changeValueForDatabaseCapture: 0,
            isRecording: false,

            /* new data for seeing contributions while creating is below */
            audioLoading: true,
            audioData: [], // this is used for saved contributions, not the new contributions!
            selectedAudioId: null,
            currentAudioElement: null, // this will be the currently selected AudioElement.
            currentAudioSegment: null, // this will be the current segment loaded into the audioPlayer.
            previousAudioSegment: null,
            nextAudioSegment: null, // this will be the next audio segment to be loaded into the audioPlayer.
            audioElementOrSegmentClicked: false,
            audioCanPlay: false, // Used to make sure audio is ready to play when marker is reached.
            audioPlayer: new Audio(),
            preloadAudioPlayer: new Audio(),
            audioElementHasBegunPlaying: false,
            filter: {
                languageSelected: "All",
                languageCodes: ["All"],
            },
            playbackStyle: "pauseplay", // this.$store.state.userData.playbackStyle ? 'continuous' : 'pauseplay', // old code that was removed by Scott Brady on February 27, 2024 - always 'pauseplay' for ease in matching of audio start times
            playbackStyleAudioFirst: false, // always false, so the audio of a contribution will play at the end of the segment. I.E. if a contribution starts at 2 seconds and has a duration of 1.5 seconds, the audio will play at 3.5 seconds
            vidPlayerVolume: null,
            // captionVolume: 1.0, // look into this and see if we need to add this code so the caption volume will update.
            VID_PLAYER_PLAY_DELAY: 1500, // 1.5 seconds

            triggerAnimationAfterRecord: false,

        };
    },
    methods: {
        turnOnRefs: function (userId) {
            this.dbRefs.subtitleRef = firebase.rtDb.ref(`${userId}/${this.textPost.audioDataId}/subtitle`);
            this.dbRefs.conversionRef = firebase.rtDb.ref(`${userId}/${this.textPost.audioDataId}/conversion`);
        },
        turnOffRefs: function() {
            this.dbRefs.subtitleRef.off();
            this.dbRefs.conversionRef.off();
        },
        changeTextCardIndexAssociationValue: function (value) {
            if (value == 'next' && ((this.textCardIndexAssociationValue + 1) <= (this.textPost.textAdded.length - 1))) {
                if (this.triggerAnimationAfterRecord) this.triggerAnimationAfterRecord = false;
                this.textCardIndexAssociationValue += 1;
            } else if (value == 'previous' && ((this.textCardIndexAssociationValue - 1) >= 0)) {
                this.textCardIndexAssociationValue -= 1;
            }
        },
        controlRecordState: function (currState, prevState) {
            // console.log("controlRecordState: ", currState, prevState);

            !this.audioPlayer.paused && this.audioPlayer.pause();

            if (currState === "@record") {
                this.contentCreationStep.complete = false;
                this.isRecording = true;


                this.segStart = Date.now();
                this.textSeg.vStart = 0; // vidPlayer.playerGetTime();
                this.emitTime = 0;

                this.captionTimer = setInterval(() => {
                    this.emitTime += this.INTERVAL;
                }, this.INTERVAL);
            }

            if (prevState === "@record") { // reset progress bar timer
                this.isRecording = false;
                clearInterval(this.captionTimer);
                // this.timePlaying = 0;
                this.emitTime = 0;

                const segEnd = Date.now();
                var dt = (Math.abs(segEnd - this.segStart) / 1000) % 60; // get seconds from vid segment difference
                // console.log("dt: ", dt);
                if (dt > this.vIgnore) {
                    // console.log("this.tawqData: ", this.tawqData);
                    // console.log("this.textSeg.segment: ", this.textSeg.segment);
                    this.textSeg.segment = this.findLargestSegId + 1;
                    this.textSeg.dt = dt;
                    this.textSeg.textCardIndexAssociationValue = this.textCardIndexAssociationValue + 1;
                    var textSegValue = JSON.parse(JSON.stringify(this.textSeg));
                    // console.log("textSegValue: ",textSegValue);
                    this.$set(this.tawqData, this.textSeg.segment, {
                        'textSeg': textSegValue,
                        'audio': (typeof this.tawqData[this.textSeg.segment] != 'undefined') ? this.tawqData[this.textSeg.segment].audio : null,
                        'caption': (typeof this.tawqData[this.textSeg.segment] != 'undefined') ? this.tawqData[this.textSeg.segment].caption : null,
                    });
                    this.textSeg.vStart = null;
                    // this.changeTextCardIndexAssociationValue("next");
                    this.triggerAnimationAfterRecord = true;
                } else { // This case only happens when a recording is not long enough, that is to say, less than half a second. So this should only be called when the record/stop button(s) are pressed in rapid succession. When this happens the 'Next' button become disabled and will not reenable unless the below function is called
                    this.checkForErrorInTawqData(this.tawqData);
                }
            }
        },
        updateTawqDataAfterUploadAudioRec: function (audioSeg) {
            // console.log("updateTawqDataAfterUploadAudioRec: ", audioSeg);
            if (audioSeg.error) { // occurs in Push.vue or Pickup.vue, when audio file fails to upload to firebase cloud storage
                // console.log("audioSeg.error: ", audioSeg.error);
                this.tawqData[audioSeg.segment].error = audioSeg.error;
                this.tawqData[audioSeg.segment].audio = audioSeg;
                this.tawqData[audioSeg.segment].caption = "*This Audio Segment Failed. Delete it to Continue*";
                this.contentCreationStep.complete = false;
            } else {
                // console.log("No error after uploading!");
                let timeout = 570000; // 9.5 minutes, just to make sure the cloud function times out.
                const timeoutId = setTimeout(() => { // because there is a timeout of 9 minutes for the cloud function, and there is no error sent if the cloud function times out, we will set a timeout function here (since this is the first place we know the audio file has been uploaded).
                    this.$emit("clearCloudFunctionTimeout", audioSeg.segment, false); // timeout function completed, which means the cloud function reached timeout limit of 9 minutes. only clear timeoutId from parent (NewPost.vue) components cloudFunctionTimeoutIds
                }, timeout);
                this.$emit("setCloudFunctionTimeout", audioSeg.segment, timeoutId);

                if (typeof this.tawqData[audioSeg.segment] === "undefined") { // we can't create a new audio object here because we won't have the video seg data for it...return;
                    // console.log("tawqData is undefined");
                    return;
                } else if (typeof this.tawqData[audioSeg.segment].audio === 'undefined' || this.tawqData[audioSeg.segment].audio === null) { // saving the audio object for the first time
                    let startTime = this.tawqData[audioSeg.segment].textSeg.vStart // time of video when record is pressed
                    // let startTime = Math.max(0, this.tawqData[audioSeg.segment].textSeg.vStart - this.tawqData[audioSeg.segment].textSeg.dt); // time of video when record is pressed minus length of recording
                    // if (this.currentAudioElement !== null && this.previousAudioSegment !== null) {
                    //     let withinSpecifiedTime = (Math.abs((this.currentAudioElement.audioData.audio[this.previousAudioSegment.segment - 1].audioStart + this.currentAudioElement.audioData.audio[this.previousAudioSegment.segment - 1].audioDur) - this.tawqData[audioSeg.segment].textSeg.vStart) <= 1.0);
                    //     let isGreaterThanCurrentSegment = (this.tawqData[audioSeg.segment].textSeg.vStart >= this.currentAudioElement.audioData.audio[this.previousAudioSegment.segment - 1].audioStart);
                    //     startTime = (this.matchAudioStartTimesWithSelectedContribution && isGreaterThanCurrentSegment && withinSpecifiedTime) ? this.previousAudioSegment.audioStart : startTime; // this.currentAudioElement.audioData.audio[this.previousAudioSegment.segment - 1].audioStart;
                    // }

                    audioSeg.audioStart = startTime;
                    audioSeg.audioDur = this.tawqData[audioSeg.segment].textSeg.dt;
                    audioSeg.audioEnd = audioSeg.audioStart + audioSeg.audioDur;

                    this.tawqData[audioSeg.segment].audio = audioSeg;
                    // console.log("this.tawqData: ", this.tawqData);
                } else { // we already have an audio object for this audio seg id (happens if they go back and forth between steps after already creating captions)
                    // console.log("already have audio object");
                    return;
                }
            }
        },
        pushTawqinData: function () {
            this.changeValueForDatabaseCapture++ // if we do not update this value when tawqinRef.set() is called below it will not recognize an update and there is a potential we will enter an error state that the user cannot get out of.
            var startSegId = this.findLargestSegId;
            // console.log("textPost: ", this.textPost);
            var data = {
                languageSelected : this.textPost.languageSelected,
                postId : this.textPost.postId,
                audioDataId : this.textPost.audioDataId,
                startSegId: startSegId,
                changeValueForDatabaseCapture: this.changeValueForDatabaseCapture,
            };
            this.tawqin = data;
            // console.log("tawqin: ", this.tawqin);
        },
        checkForErrorInTawqData: function (data) { // This function is used to make sure there is not an error in any of the completed AudioSegments. If there is we don't allow the user to move on in the creation process.
            if (this.isRecording && !this.contentCreationStep.complete) return;
            this.contentCreationStep.complete = !Object.values(data).some(item => (item.error || (item.caption === null)));
        },
        setAudioSegmentURL: function (filename, location) {
            let storageRef = firebase.storage.ref();
            storageRef.child(`${location}`).getDownloadURL().then((url) => {
                this.tawqData[parseInt(filename)].audio.audioURL = url;
                this.checkForErrorInTawqData(this.tawqData);
                this.$emit("clearCloudFunctionTimeout", parseInt(filename), true); // cloud function completed, clear timeout function and timeoutId from parent (NewPost.vue) components cloudFunctionTimeoutIds
            }).catch((error) => {
                // console.log("An error occured when setting the audio segment url. The error is: ", error);
                console.log("An error occured when setting the audio segment url. The error is: ", error);
                this.$store.commit('alertUser', { show: true, text: `Oops, Couldn't retrieve your audio segments at this time`, type: 'snackbar' });
            });
        },
        playAudioSegment: function(audioSegId) {
            !this.audioPlayer.paused && this.audioPlayer.pause(); // if the player is NOT paused then pause, else nothing;

            let audioToPlay = this.tawqData[audioSegId].audio;
            this.audioPlayer.src = audioToPlay.audioURL;
            this.audioPlayer.play();
        },
        deleteAudioSegment: function(data) { // this function deletes the segment from the firestore database
            if (data.audioSegmentFailed) { this.deleteAudioSegmentLocally(data); return; } // segment failed to upload, only need to delete locally

            var storageRef = firebase.storage.ref("audioSegments");
            var audioRef = storageRef.child(`/${this.textPost.postId}/${this.textPost.audioDataId}/${data.audioSegId}`);

            audioRef.delete().then(() => {
                    this.deleteAudioSegmentLocally(data); // go delete the local list of audioData
            }).catch((error) => {
                console.log("error deleting audio file: ", error.message);
                this.$store.commit('alertUser', { show: true, text: `Couldn't delete the audio file. Error: ${error.message}`, type: 'snackbar' });
            });
        },
        deleteAudioSegmentLocally: function (data) {
            this.$delete(this.tawqData, data.audioSegId);
            this.pushTawqinData();
            this.checkForErrorInTawqData(this.tawqData);
            if (!this.hasAudio) this.contentCreationStep.complete = false;
        },
        updateScroll: function() {
            var element = document.getElementsByClassName("caption-card-container")[0];
            let height = element.scrollHeight;
            element.scrollTop = ( 0 - height );
        },
        sendEditStateToPush: function (editState) {
            this.editState = editState;
        },
    },
    computed: {
        isMobile(){
            return this.$store.state.isMobileDevice;
        },
        isIOS(){
            return this.$store.state.isIOSDevice;
        },
        currentPost(){
            return this.$store.state.currentPost;
        },
        userData(){
            return this.$store.state.userData;
        },
        userGroups(){
            return this.$store.state.userGroups;
        },
        contentCreationStep: {
            get(){
                return this.$store.state.newTextPost.contentCreationStep;
            },
            set(value){
                this.$store.commit('newTextPost/saveContentCreationStep', value);
            }
        },
        tawqData: {
            get(){
                let data = this.$store.state.newTextPost.tawqData;
                if (Object.keys(data).length > 0) this.showCaptions = true;
                else this.showCaptions = false;
                return data;
            },
            set(value){
                this.$store.commit('newTextPost/saveTawqData', value);
            }
        },
        findLargestSegId: function() {
            const tawqDataKeys = Object.keys(this.tawqData);

            if (tawqDataKeys.length <= 0) return 0;

            return tawqDataKeys.reduce((largest, key) => {
                const parsedKey = parseInt(key);
                return parsedKey > largest ? parsedKey : largest;
            }, 0);
        },
        textPost: {
            get(){
                return this.$store.state.newTextPost.textPost;
            },
            set(value){
                this.$store.commit('newTextPost/saveTextPost', value);
            }
        },
        hasAudio () {
            return Object.values(this.tawqData).some((item) => item.audio !== undefined && item.audio !== null);
        },
    },
    watch: {},
    created: function () {
        if (this.isIOS) this.playbackStyle = 'pauseplay';
        this.turnOnRefs(firebase.auth.currentUser.uid); //update realtime refs with current user Id to allow connection to mobile
        this.pushTawqinData();
    },
    mounted: function () {
        // this.setContributionCollectionContainerHeight();
        // window.addEventListener('resize', this.setContributionCollectionContainerHeight);

        this.dbRefs.subtitleRef.on("child_added", (snapshot) => {
            if (snapshot.val() === null) return;

            if (typeof this.tawqData[parseInt(snapshot.val().audioSegId)] === "undefined") {
                // console.log('ERROR: NOT SAVING CAPTION OBJECT BECAUSE THIS AUDIO ID IS UNDEFINED IN TAWQ DATA. audioSegId = ', snapshot.val().audioSegId); // FIGURE OUT HOW TO HANDLE THIS ERROR STATE!!!
                this.$emit("clearCloudFunctionTimeout", parseInt(snapshot.val().idToDelete), true); // cloud function failed, clear timeout function and timeoutId from parent (NewPost.vue) component
                this.tawqData[parseInt(snapshot.val().idToDelete)].error = true;
                this.tawqData[parseInt(snapshot.val().idToDelete)].caption = "*This Audio Segment Failed. Delete it to Continue*";
                this.contentCreationStep.complete = false;
                return;
            } else if (typeof this.tawqData[parseInt(snapshot.val().audioSegId)].caption === 'undefined' || this.tawqData[parseInt(snapshot.val().audioSegId)].caption === null) { // Ran the first time we are adding a caption for the specified audioSegId.
                const formattedCaption = typeof snapshot.val().subtitle !== 'undefined' ? snapshot.val().subtitle.charAt(0).toUpperCase() + snapshot.val().subtitle.slice(1) : "";
                // console.log("formattedCaption: ", formattedCaption);
                this.tawqData[parseInt(snapshot.val().audioSegId)].caption = formattedCaption || snapshot.val().subtitle || "";
            } else { // we already have a caption for this audio seg id (happens if they go back and forth between steps after already creating captions)
                return;
            }
        },(error) => {
            console.error(error.message);
            this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
        });

        this.dbRefs.conversionRef.on("child_added", (snapshot) => {
            if (snapshot.val() === null) return;

            if (typeof this.tawqData[parseInt(snapshot.val().filename)] === "undefined") {
                this.$emit("clearCloudFunctionTimeout", parseInt(snapshot.val().idToDelete), true); // cloud function failed, clear timeout function and timeoutId from parent (NewPost.vue) component
                this.tawqData[parseInt(snapshot.val().idToDelete)].error = true;
                this.tawqData[parseInt(snapshot.val().idToDelete)].audio.audioURL = "failed";
                this.contentCreationStep.complete = false;
                return;
            } else {
                if (typeof this.tawqData[parseInt(snapshot.val().filename)].audio.audioURL != 'undefined' && this.tawqData[parseInt(snapshot.val().filename)].audio.audioURL != null) { // we have already retrieved the url for the audio (they go back and forth)
                    console.log("already retrieved the url");
                    // FIGURE OUT HOW TO HANDLE THIS ERROR STATE!!!
                    // do we need to clear the timeout here?
                    // this.$emit("clearCloudFunctionTimeout", parseInt(snapshot.val().idToDelete), true); // cloud function failed, clear timeout function and timeoutId from parent (NewPost.vue) component
                    return;
                }
                let filename = snapshot.val().filename;
                let location = snapshot.val().location;
                // we need to retrieve the url's for the audioSegments here, because the cloud function converts them to mp4 which will change the the download URL that they originally have when uploaded to storage
                this.setAudioSegmentURL(filename, location);
            }
        },(error) => {
            console.error(error.message);
            this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${error.message}`, type: 'snackbar' });
        });
    },
    beforeDestroy: function () {
        if (this.audioPlayer) {
            this.audioPlayer.pause();
            this.audioPlayer.remove();
        }
        clearInterval(this.captionTimer);
        this.turnOffRefs();
        // we remove the three refs below because if not, then it does a lot of unneccessary work anytime switching between steps while creating a post,
        // and this is the only component that needs that info
        this.dbRefs.subtitleRef.remove();
        this.dbRefs.conversionRef.remove();
        // window.removeEventListener('resize', this.setContributionCollectionContainerHeight);
    },
};
</script>

<style>
.smallText {
    font-size: 10px;
}

.height--80 {
    height: 80vh !important;
    max-height: 80vh !important;
}

.caption-card-container {
    max-height: 20vh;
    overflow-y: scroll;
    overflow-x: hidden;
    border-radius: 10px;
}

.caption-card-container::-webkit-scrollbar {
    width: 7px;
    height: 100%;
}

/* Handle */
.caption-card-container::-webkit-scrollbar-thumb {
    background: #86c232 !important;
    height: 20% !important;
}

.contribution-collection-menu-container {
    z-index: 5;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60vh;
    width: 100%;
    overflow-y: scroll;
}

.dialog-slide-up-enter-active {
    animation: dialog-slide-up 0.2s ease-out;
}

.dialog-slide-up-leave-active {
    animation: dialog-slide-up 0.2s ease-out reverse;
}

@keyframes dialog-slide-up {
    from{
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
}

/* XS */
@media (max-width: 600px){
    .caption-card-container {
        max-height: 35vh;
        min-height: 15vh;
    }
}

/* SM */
@media (min-width: 601px) and (max-width: 960px){
    .caption-card-container {
        max-height: 28vh;
        min-height: 12vh;
    }
}

/* MD */
@media (min-width: 961px) and (max-width: 1264px){
    .caption-card-container {
        max-height: 40vh;
        min-height: 10vh;
    }
}

/* LG */
@media (min-width: 1265px) and (max-width: 1904px){
    .caption-card-container {
        max-height: 22vh;
    }
}

/* XL */
@media (min-width: 1905px){
    .caption-card-container {
        max-height: 23vh;
    }
}
</style>


<!-- <script>
export default {
    props: [],
    components: {},
    data: function () {
        return {};
    },
    methods: {},
    computed: {
        isMobile(){
            return this.$store.state.isMobileDevice;
        },
    },
    mounted: function () {},
    created: function () {},
    beforeDestroy: function () {},
}
</script>

<style>
</style> -->
